import React from 'react';
import {createRoot} from 'react-dom/client';
import Checkout from './checkout/checkout';
// import {StripeProvider,Elements} from 'react-stripe-elements';
import ErrorBoundary from './app-error';
import * as Sentry from '@sentry/react';
import {logger, setErrorReporter} from './logger';
import {installAntiforgeryRetry} from './global/antiforgery';

declare var __company_name: string;
declare var __domain_name: string;
declare var __is_production: string;

Sentry.init({
    dsn: 'https://b2db459d7dc0ea78a26c57e6e1ee5647@o367868.ingest.us.sentry.io/4508019535380480',
    // The bundles carry the production DSN on every host: pages served by a local DF4 never report (staging still does).
    enabled: !/^(localhost|127\.0\.0\.1|df4\.microgsd\.net)$/.test(location.hostname),
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: __is_production === '1' ? 0.05 : 1,
    tracePropagationTargets: ['localhost', __domain_name],
    ignoreErrors: ['Non-Error exception captured', 'Non-Error promise rejection captured', 'InitializationError'],
    denyUrls: [/s\.pinimg\.com/, /connect\.facebook\.net/, /googletagmanager\.com/, /google-analytics\.com/, /bat\.bing\.com/, /klaviyo\.com/],
    environment: __is_production === '1' ? 'production' : 'development',
});
setErrorReporter(r => (r.kind === 'exception' ? Sentry.captureException(r.error, {extra: r.extra, fingerprint: r.fingerprint, tags: r.tags}) : Sentry.captureMessage(r.message, {level: 'error', extra: r.extra, fingerprint: r.fingerprint})));
// A stale antiforgery token: refresh it and retry the request once (global/antiforgery.ts).
installAntiforgeryRetry();

const myErrorHandler = (error: Error, componentStack: string) => {
    logger.log('ERROR', error.message);
};

document.addEventListener('DOMContentLoaded', function () {
    const container: HTMLElement = document.getElementById('checkoutv4') as HTMLElement;
    if (container) {
        const root = createRoot(container);
        root.render(
            <ErrorBoundary>
                <Checkout />
            </ErrorBoundary>,
        );
    }
});
